import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import errorHandler from "../../utils/errorHandler";
import { capitalize, capitalizeFirstLetter, displayPermissions } from "../../utils/helpers";
import ApiService from "../../services/categoryManagementApi";
import { Loader } from "../../components/customLoader";

const { rateAndReviewApi } = ApiService;

const ViewRateAndReview = ({ id, show, onHide }) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);
  console.log("data",data);
  

  const userData = async () => {
    try {
      setLoading(true);
      const response = await rateAndReviewApi.getById({ id: id });
      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    userData();
  }, []);
  
  return (
    <Dialog maxWidth="md" fullWidth={true} open={show} onClose={onHide}>
      <DialogTitle as="h2">Rate And Review Details</DialogTitle>
      {loading ? (
        <Loader />
      ) : (
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography variant="subtitle1">Full Name</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {capitalize(data?.orderId?.userId?.name)}{" "}
              </DialogContentText>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography variant="subtitle1">Email</Typography>
              <DialogContentText sx={{ marginBlockStart: "1em" }}>
                {capitalize(data?.orderId?.userId?.email)}{" "}
              </DialogContentText>
            </Grid>
            <Divider />
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Driver Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Phone No.</TableCell>
                    <TableCell>Rating</TableCell>
                    <TableCell>Review</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data && (
                    <TableRow>
                      <TableCell>{data?.driverId?.name}</TableCell>
                      <TableCell>{data?.driverId?.email}</TableCell>
                      <TableCell>{data?.driverId?.phoneNumber}</TableCell>
                      <TableCell>{data?.driverRating}</TableCell>
                      <TableCell>{data?.driverReview}</TableCell>
                    </TableRow>
                  ) || (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No Rating & Review
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>   
            <Divider />
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Product Name</TableCell>
                    <TableCell >Rating</TableCell>
                    <TableCell align="center">Review</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.productData?.map((product, index) => (
                    <TableRow key={index}>
                      <TableCell>{capitalizeFirstLetter(product?.productId?.name)}</TableCell>
                      <TableCell>{product.productRating}</TableCell>
                      <TableCell align="center">{product.productReview}</TableCell>
                    </TableRow>
                  )) || (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                      No Rating & Review
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>          
          </Grid>
          <DialogActions>
            <Button variant="outlined" onClick={() => onHide()} type="submit">
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default ViewRateAndReview;
